/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchWithAmountAndQuantity } from './BranchWithAmountAndQuantity';
import {
    BranchWithAmountAndQuantityFromJSON,
    BranchWithAmountAndQuantityFromJSONTyped,
    BranchWithAmountAndQuantityToJSON,
    BranchWithAmountAndQuantityToJSONTyped,
} from './BranchWithAmountAndQuantity';

/**
 * 
 * @export
 * @interface BusinessReportBranchesWithDiscountAmountAndQuantityResponse
 */
export interface BusinessReportBranchesWithDiscountAmountAndQuantityResponse {
    /**
     * 
     * @type {Array<BranchWithAmountAndQuantity>}
     * @memberof BusinessReportBranchesWithDiscountAmountAndQuantityResponse
     */
    data: Array<BranchWithAmountAndQuantity>;
}

/**
 * Check if a given object implements the BusinessReportBranchesWithDiscountAmountAndQuantityResponse interface.
 */
export function instanceOfBusinessReportBranchesWithDiscountAmountAndQuantityResponse(value: object): value is BusinessReportBranchesWithDiscountAmountAndQuantityResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BusinessReportBranchesWithDiscountAmountAndQuantityResponseFromJSON(json: any): BusinessReportBranchesWithDiscountAmountAndQuantityResponse {
    return BusinessReportBranchesWithDiscountAmountAndQuantityResponseFromJSONTyped(json, false);
}

export function BusinessReportBranchesWithDiscountAmountAndQuantityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReportBranchesWithDiscountAmountAndQuantityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BranchWithAmountAndQuantityFromJSON)),
    };
}

export function BusinessReportBranchesWithDiscountAmountAndQuantityResponseToJSON(json: any): BusinessReportBranchesWithDiscountAmountAndQuantityResponse {
    return BusinessReportBranchesWithDiscountAmountAndQuantityResponseToJSONTyped(json, false);
}

export function BusinessReportBranchesWithDiscountAmountAndQuantityResponseToJSONTyped(value?: BusinessReportBranchesWithDiscountAmountAndQuantityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BranchWithAmountAndQuantityToJSON)),
    };
}

